import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { EServiceType, IPublishOption } from '../../../../reducers';

interface IMapAuctionTermParams {
  bet: number;
  period: IPublishOption;
  services: EServiceType[];
}

export function mapAuctionTerm(params: IMapAuctionTermParams): ICheckPublishTermSchema {
  const { bet, period, services } = params;
  const { type, days, tariffIdentificator } = period;

  return {
    type,
    days,
    services,
    tariffIdentificator,
    dynamicPrice: bet,
  };
}
